import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { Badge } from 'src/app/classes/badge';

@Component({
  selector: 'mercury-badge',
  standalone: true,
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent implements OnInit {
  @Input() badge!: Badge;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    try {
      this.badge.positiony &&
        this.renderer.addClass(this.el.nativeElement, this.badge.positiony);
      this.badge.positionx &&
        this.renderer.addClass(this.el.nativeElement, this.badge.positionx);
      this.badge.class &&
        this.renderer.addClass(this.el.nativeElement, this.badge.class);
      this.badge.colour &&
        this.renderer.setStyle(
          this.el.nativeElement,
          'color',
          this.badge.colour
        );
      this.badge.background &&
        this.renderer.setStyle(
          this.el.nativeElement,
          'background',
          this.badge.background
        );
    } catch (err) {
      console.error(err);
    }
  }
}
